import type { PartnerSessionMetadata } from '@utils/partnerSession';
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface PartnerSessionState {
  partnerSession: PartnerSessionMetadata | null;
}

const initialState: PartnerSessionState = {
  partnerSession: null,
};

const partnerSessionSlice = createSlice({
  name: 'partnerSession',
  initialState,
  reducers: {
    setPartnerSession: (
      state,
      action: PayloadAction<PartnerSessionMetadata>,
    ) => {
      state.partnerSession = {
        partnerId: action.payload.partnerId,
        source: action.payload.source,
        city: action.payload.city,
        locationFilters: action.payload.locationFilters,
        notes: action.payload.notes,
        callbackUrl: action.payload.callbackUrl,
      };
    },
    clearPartnerSession: (state) => {
      state.partnerSession = null;
    },
    // Marks the redirect as used, so it never fires twice.
    clearPartnerCallbackUrl: (state) => {
      if (state.partnerSession) {
        state.partnerSession.callbackUrl = undefined;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      (action) =>
        [
          'login/resetStep',
          'sendOtp/fulfilled',
          'verifyOtp/fulfilled',
        ].includes(action.type),
      (state) => {
        state.partnerSession = null;
      },
    );
  },
});

export const {
  setPartnerSession,
  clearPartnerSession,
  clearPartnerCallbackUrl,
} = partnerSessionSlice.actions;

export default partnerSessionSlice.reducer;
